import type { AiCostLimitAlertsFetchedAction } from '@Application/AiCostLimits/Alerts/Actions/aiCostLimitAlertsFetched';
import type { AiCostLimitCreatedAction } from '@Application/AiCostLimits/Limits/Actions/aiCostLimitCreated';
import type { AiCostLimitDeletedAction } from '@Application/AiCostLimits/Limits/Actions/aiCostLimitDeleted';
import type { AiCostLimitUpdatedAction } from '@Application/AiCostLimits/Limits/Actions/aiCostLimitUpdated';
import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import AiCostLimitAlertView from '@UI/Store/AiCostLimitAlerts/Views/AiCostLimitAlertView';
import AiCostLimitAlertsListView from '@UI/Store/AiCostLimitAlerts/Views/AiCostLimitAlertsListView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type AiCostLimitAlertsStore = {
	alerts: AiCostLimitAlertsListView | null;
};

const initialState: AiCostLimitAlertsStore = {
	alerts: null,
};

type Actions =
	| AiCostLimitAlertsFetchedAction
	| AiCostLimitCreatedAction
	| AiCostLimitUpdatedAction
	| AiCostLimitDeletedAction
	| UserRevokedAction;

const whenAiCostLimitAlertsFetched = (
	store: AiCostLimitAlertsStore,
	action: AiCostLimitAlertsFetchedAction,
): AiCostLimitAlertsStore => ({
	...store,
	alerts: new AiCostLimitAlertsListView(
		action.accountId,
		action.payload.map((alert) => new AiCostLimitAlertView(alert)),
	),
});

// Any change of a limit invalidates the banner: it is read again on the next mount.
const whenAiCostLimitChanged = (): AiCostLimitAlertsStore => initialState;

const whenUserRevoked = (): AiCostLimitAlertsStore => initialState;

export default registerStore<'aiCostLimitAlertsStore', Actions>(
	'aiCostLimitAlertsStore',
	createSliceReducer({
		AI_COST_LIMIT_ALERTS_FETCHED: whenAiCostLimitAlertsFetched,
		AI_COST_LIMIT_CREATED: whenAiCostLimitChanged,
		AI_COST_LIMIT_UPDATED: whenAiCostLimitChanged,
		AI_COST_LIMIT_DELETED: whenAiCostLimitChanged,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
